import {
  IGetTimeAndActivityReportsParams,
  TimeAndActivityReportsParamsForDownloading,
} from 'features/timeAndActivityReports/timeAndActivityReportsTypes';
import { apiClient } from './axiosInstance';
import { AxiosResponse } from 'axios';

export type CreateDownloadLinkFromPdfParams = {
  startDate: string;
  endDate: string;
  organizationName: string;
  reportType: 'timeAndActivity' | 'amountsOwed';
  sumDateRanges: boolean;
  detailedReports: boolean;
  noTimeOff: boolean;
};

export const createDownloadLinkFromPdf = (
  params: CreateDownloadLinkFromPdfParams
) => {
  return (response: AxiosResponse<Blob>) => {
    const {
      startDate,
      endDate,
      organizationName,
      reportType,
      sumDateRanges,
      detailedReports,
      noTimeOff
    } = params;
    const url = window.URL.createObjectURL(response.data);

    // const fileName = `${organizationName}_${startDate}_${endDate}_${reportType}.pdf`;
    const parameters = [
      sumDateRanges ? "summedDateRanges" : "",
      detailedReports ? "detailedReport" : "",
      noTimeOff ? "noTimeOff" : ""
    ];

    const fileName = organizationName + "_" +
      reportType + "_report_" +
      startDate + "_to_" + endDate +
      "_params_" + parameters.filter(Boolean).join("&") + 
      ".pdf";

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);

    link.click();

    link.parentNode?.removeChild(link);

    window.open(url, '_blank');
  };
};

export const fetchTimeAndActivityReports = async (
  params: IGetTimeAndActivityReportsParams
) => {
  const {
    isMyReports,
    startDate,
    endDate,
    columns,
    sumDateRanges,
    noTimeOff,
    clientsIds,
    projectsIds,
    membersIds,
  } = params;
  const startDateQuery = startDate ? `startDate=${startDate}&` : '';
  const endDateQuery = endDate ? `endDate=${endDate}&` : '';
  const columnsQuery =
    columns && columns.length > 0
      ? `columns=${columns.join('&columns=')}&`
      : '';
  const sumDateRangesQuery = sumDateRanges
    ? `sumDateRanges=${sumDateRanges}&`
    : '';
  const noTimeOffQuery = noTimeOff
    ? `noTimeOff=${noTimeOff}&`
    : '';
  const clientsQuery =
    clientsIds && clientsIds.length > 0
      ? `clientsIds=${clientsIds.join('&clientsIds=')}&`
      : '';
  const projectsQuery =
    projectsIds && projectsIds.length > 0
      ? `projectsIds=${projectsIds.join('&projectsIds=')}&`
      : '';
  const membersQuery =
    membersIds && membersIds.length > 0
      ? `membersIds=${membersIds.join('&membersIds=')}&`
      : '';

  const queryStr = `?${startDateQuery}${endDateQuery}${columnsQuery}${sumDateRangesQuery}${noTimeOffQuery}${clientsQuery}${projectsQuery}${membersQuery}`;

  if (isMyReports) {
    return await apiClient.get(`/reports/time-and-activity/my${queryStr}`);
  } else {
    return await apiClient.get(`/reports/time-and-activity${queryStr}`);
  }
};

export const downloadTimeAndActivityReports = async (
  params: TimeAndActivityReportsParamsForDownloading
) => {
  const {
    startDate,
    endDate,
    columns,
    sumDateRanges,
    noTimeOff,
    clientsIds,
    projectsIds,
    membersIds,
    organizationName,
    reportType,
    isMyReports,
  } = params;
  const startDateQuery = startDate ? `startDate=${startDate}&` : '';
  const endDateQuery = endDate ? `endDate=${endDate}&` : '';
  const columnsQuery =
    columns && columns.length > 0
      ? `columns=${columns.join('&columns=')}&`
      : '';
  const sumDateRangesQuery = sumDateRanges
    ? `sumDateRanges=${sumDateRanges}&`
    : '';
  const noTimeOffQuery = noTimeOff
    ? `noTimeOff=${noTimeOff}&`
    : '';
  const clientsQuery =
    clientsIds && clientsIds.length > 0
      ? `clientsIds=${clientsIds.join('&clientsIds=')}&`
      : '';
  const projectsQuery =
    projectsIds && projectsIds.length > 0
      ? `projectsIds=${projectsIds.join('&projectsIds=')}&`
      : '';
  const membersQuery =
    membersIds && membersIds.length > 0
      ? `membersIds=${membersIds.join('&membersIds=')}&`
      : '';

  const queryStr = `?${startDateQuery}${endDateQuery}${columnsQuery}${sumDateRangesQuery}${noTimeOffQuery}${clientsQuery}${projectsQuery}${membersQuery}`;

  await apiClient
    .get(`/reports/time-and-activity${isMyReports ? "/my" : ""}/pdf${queryStr}`, {
      headers: { 'Content-Type': 'application/pdf' },
      responseType: 'blob',
    })
    .then(
      createDownloadLinkFromPdf({
        startDate,
        endDate,
        reportType,
        organizationName,
        sumDateRanges: sumDateRanges === 'true',
        detailedReports: false,
        noTimeOff: noTimeOff === 'true'
      })
    )
    .catch((error: unknown) => {
      console.error('Error downloading file:', error);
    });
};
